import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function ImpersonationBanner() {
  const navigate = useNavigate();
  const impersonationData = localStorage.getItem('impersonation');

  if (!impersonationData) return null;

  const data = JSON.parse(impersonationData);

  const handleExit = () => {
    // Restore super admin session
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('tenant');
    localStorage.removeItem('impersonation');
    navigate('/super-admin/tenants');
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between shadow-lg"
      data-testid="impersonation-banner"
      style={{ fontFamily: 'DM Sans, sans-serif' }}
    >
      <div className="flex items-center gap-2 text-sm font-semibold">
        <ShieldAlert className="h-4 w-4" />
        <span>Impersonation Mode</span>
        <span className="mx-1">—</span>
        <span>Viewing as <strong>{data.userName}</strong> ({data.tenantName})</span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="bg-amber-600 border-amber-700 text-white hover:bg-amber-700 text-xs h-7"
        onClick={handleExit}
        data-testid="exit-impersonation-btn"
      >
        <ArrowLeft className="h-3 w-3 mr-1" />
        Back to Super Admin
      </Button>
    </div>
  );
}
